import React, { useEffect, useState } from "react";
import { ReportCard } from "./ReportCard.tsx";
import { ReportModel } from "./_core/_model.ts";
import { GetReport, RemoveMeFromReport } from "./_core/_request.ts";
import { useToast } from "../../context/ToastContext.tsx";
import LoadingIndicator from "../../UIComponents/LoadingIndicator.tsx";
import SearchTextbox from "../../UIComponents/SearchTextbox.tsx";
import { TiInfo } from "react-icons/ti";
import { UserModel } from "../../_core/_model.ts";
import { AnimatePresence, motion } from "framer-motion";
import { FaCheckToSlot } from "react-icons/fa6";


interface request {
    user: UserModel
}

export const UserReports: React.FC<request> = ({ user }) => {
    const [reports, setReports] = useState<ReportModel[] | null>(null);
    const [filters, setFilters] = useState<string>("");
    const { showToast } = useToast();

    const filteredReports = reports?.filter((r) =>
        r.reportName.toLowerCase().includes(filters.toLowerCase())
    );

    const getReports = () => {
        GetReport({
            emailId: user.email,
            userID: user.userID
        }).then((x) => {
            setReports([...x.data]);
        })
    }

    useEffect(() => {
        getReports();
    }, [])

    const handleToggle = (id: number) => {
        RemoveMeFromReport({
            reportAutoID: id,
            userID: user.userID
        }).then((x) => {
            showToast({
                message: "Removed for distribution",
                type: "success",
                duration: 5000
            });
            getReports();
        })
    };

    return (
        <div className="container mt-4 mx-0 px-0">
            {
                reports == null ?
                    <LoadingIndicator {...{ message: "Loading reports" }} /> :
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }} className="j_rep_search j_u_r_srch">
                            <SearchTextbox {...{
                                onChange: (e) => { setFilters(e.target.value) },
                                placeholder: "Search by report name",
                                value: filters
                            }} />
                        </div>
                        {
                            (filteredReports?.length != 0) &&
                            <div>
                                <span className="text-muted d-flex align-items-center gap-1 small">
                                    <TiInfo size={16} />
                                    These reports are configured for distribution and include {user.userFirstName + " " + user.userLastName} as a recipient.
                                </span>
                            </div>
                        }
                        <div className="mt-1">
                            {filteredReports?.map((r) => (
                                <ReportCard key={r.reportID} userName={user.userFirstName + " " + user.userLastName} report={r} onToggle={handleToggle} />
                            ))}

                            {filteredReports?.length === 0 && (
                                <AnimatePresence>
                                    <motion.div
                                        className="d-flex flex-column align-items-center justify-content-center text-muted-theme p-5 m-4 bg-gray"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5, ease: "easeOut" }}
                                        style={{
                                            border: "2px dashed #dee2e6",
                                            borderRadius: "10px",
                                            marginTop: "40px",
                                        }}
                                    >
                                        <FaCheckToSlot size={60} color="#adb5bd" className="mb-3" />
                                        <h5 className="fw-semibold">No Report Found</h5>
                                        {
                                            !filters.isEmpty() ?
                                                <p className="text-center" style={{ maxWidth: 400 }}>
                                                    No Report found for selected filter.
                                                </p> :
                                                <p className="text-center" style={{ maxWidth: 400 }}>
                                                    It looks like there are no Reports scheduled for {user.userFirstName + " " + user.userLastName}.
                                                    You can manage it from Report Distribution section.
                                                </p>
                                        }
                                    </motion.div>
                                </AnimatePresence>
                            )}
                        </div>
                    </>
            }

        </div>
    );
};

export default UserReports;
